module.exports = __webpack_public_path__ + "static/img/66.3a278b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/66.jpg
// module id = jymH
// module chunks = 0